'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIFireAlarm from 'UIComponents/alert/UIFireAlarm';
import FintechOutageBannerTitle from './FintechOutageBannerTitle';
import ActionContextPropType from '../propTypes/ActionContextPropType';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
import { THIRD_PARTY_SERVICES } from '../constants/thirdPartyServices.constants';
import FintechOutageBannerMessage from './FintechOutageBannerMessage';
import AvailabilityStatusPropType from '../propTypes/AvailabilityStatusPropType';
import ThirdyPartyServicesPropType from '../propTypes/ThirdyPartyServicesPropType';

const FintechOutageBanner = ({
  availabilityStatus,
  requiredServices = [THIRD_PARTY_SERVICES.ZUORA],
  actionContext = ACTION_CONTEXTS.ANY
}) => {
  if (requiredServices.indexOf(THIRD_PARTY_SERVICES.ZUORA) > -1) {
    const zuoraStatus = availabilityStatus.zuora;
    const isZuoraDown = (zuoraStatus || {}).isDown;

    if (isZuoraDown) {
      return /*#__PURE__*/_jsx(UIFireAlarm, {
        closeable: false,
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FintechOutageBannerTitle, {
          actionContext: actionContext,
          serviceAvailabilityStatus: zuoraStatus
        }),
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FintechOutageBannerMessage, {
            serviceAvailabilityStatus: zuoraStatus
          })
        })
      });
    }
  }

  return null;
};

FintechOutageBanner.propTypes = {
  availabilityStatus: AvailabilityStatusPropType.isRequired,
  requiredServices: ThirdyPartyServicesPropType,
  actionContext: ActionContextPropType
};
export default FintechOutageBanner;